module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG1fefd4a6866580ab21cf6d347ea4d160.1fefd4a6.png";